import React, { FC, ReactNode, useState } from "react";
import NavBar from "./NavBar";
import Sidebar from "./Sidebar";

const Container = (props: Props) => {
  const { children, loading } = props;
  const [open, setOpen] = useState(false);

  const handleDrawerToggle = () => {
    setOpen(!open);
  };

  // NavBar sits outside the flex row, as it does in StaticContainer. It
  // renders the donation notice in the page flow above the fixed header, and
  // inside `.container` (display: flex) the notice became a column beside the
  // page instead of a bar across the top.
  return (
    <>
      <NavBar handleDrawerToggle={handleDrawerToggle} />
      <div className="container">
        {!loading ? (
          <Sidebar open={open} handleDrawerToggle={handleDrawerToggle} />
        ) : null}
        <main id="main-content" className="main">
          {children}
        </main>
      </div>
    </>
  );
};

interface Props {
  children: ReactNode;
  loading?: boolean;
}

export default Container;
